import { GridColumnHeader } from '../components/Grid/types';
import type { Attribute, DataSource } from '../types/entities.types';
import { getSearchableFields } from '../utils/searchable.utils';

const gridHeaders: GridColumnHeader[] = [
  {
    name: 'businessMetadata.asset_name',
    label: 'Name',
    width: '30%',
    filter: {
      type: 'text',
      remoteSearchFields: ['asset_name'],
    },
    sortable: true,
    remoteSortField: 'asset_name',
  },
  {
    name: 'businessMetadata.asset_id',
    label: 'Asset ID',
    width: '20%',
    filter: {
      type: 'text',
      remoteSearchFields: ['asset_id'],
    },
  },
  {
    name: 'technicalMetadata.env',
    label: 'Environment',
    width: '20%',
    filter: {
      type: 'aggregation',
      aggregationName: 'env_aggregation',
      remoteSearchFields: ['env'],
      filterSelectProps: {
        isClearable: true,
      },
    },
    sortable: true,
    remoteSortField: 'env',
  },
  {
    name: 'businessMetadata.owner',
    label: 'Owner',
    width: '15%',
    remoteSortField: 'owner',
    filter: {
      type: 'text',
      remoteSearchFields: ['owner'],
    },
  },
  { name: 'lineage', label: 'Lineage', width: '10%' },
];

const attributesMap: Attribute[] = [
  {
    name: 'businessMetadata.asset_name',
    label: 'Table Name',
    showInColumn: 0,
    description: 'Table Name',
  },
  {
    name: 'businessMetadata.asset_id',
    label: 'Table Id',
    showInColumn: 0,
    description: 'Table Id',
  },
  {
    name: 'businessMetadata.owner',
    label: 'Owner',
    showInColumn: 0,
    description: 'Owner',
  },
  {
    name: 'technicalMetadata.env',
    label: 'Environment',
    showInColumn: 0,
    description: 'Asset environment',
  },
  {
    name: 'technicalMetadata.asset_status',
    label: 'Asset Status',
    showInColumn: 0,
    description: 'Asset status',
  },
  {
    name: 'sourceSpecificMetadata.TableauDataset.container_description',
    label: 'Container Description',
    showInColumn: 0,
    description: 'Description',
  },
  {
    name: 'sourceSpecificMetadata.TableauDataset.container_urn',
    label: 'Container Urn',
    showInColumn: 0,
    description: 'Container Urn',
  },
  {
    name: 'sourceSpecificMetadata.TableauDataset.datahub_urn',
    label: 'Datahub Urn',
    showInColumn: 1,
    description: 'Datahub Urn',
  },
  {
    name: 'sourceSpecificMetadata.TableauDataset.custom_fields',
    label: 'Custom Fields',
    showInColumn: 1,
    description: 'Custom Fields',
    type: 'array',
  },
  {
    name: 'technicalMetadata.usageMetadata.last_ingested',
    label: 'Last Ingested',
    showInColumn: 1,
    description: 'Last Ingested',
    type: 'date',
  },
];

const customQueryForListPage = `
  TableauDataset {
    container_urn
    container_description
    datahub_urn
  }
`;

const customQueryForDetailsPage = `
  TableauDataset {
    container_urn
    container_description
    datahub_urn
    custom_fields {
      name
      value
    }
    columns {
      columnName
      description
      businessDescription
      dataType
      defaultValue
      nullable
      dataTypeDetails
    }
  }
`;

const searchableFields = [...getSearchableFields(attributesMap), 'Column Names'];

export const TableauDatasetConfig: DataSource = {
  id: '10',
  name: 'TableauDataset',
  showColumns: true,
  showPartitionColumns: false,
  showLineage: true,
  showLineageTable: true,
  showLineagePipeline: false,
  showLineageQuery: false,
  showLineageCloned: false,
  showLineageCW: false,
  showLineageColumn: false,
  showLineageDashboard: false,
  gridHeaders,
  attributesMap,
  customQueryForListPage,
  customQueryForDetailsPage,
  glossary: false,
  searchableFields,
};

// Validation error of type SubSelectionRequired: Sub selection required for type null of field custom_fields @ 'getAssets/assets/sourceSpecificMetadata/Looker/custom_fields'
